// extracted by mini-css-extract-plugin
export default {"root":"Alert_root__OFgCk","heading":"Alert_heading__v3dkj","content":"Alert_content__D2t72","warning":"Alert_warning__nx85A","danger":"Alert_danger__qz7Pf"};